import React from "react";

class RaisedButton extends React.Component {
  render() {
    const { theme, disabled } = this.props;

    let themeString = "";
    if (theme) {
      themeString = ` RaisedButton-Theme${theme}`;
    }

    return (
      <button
        className={
          "RaisedButton" +
          (disabled ? " RaisedButton-Disabled" : "") +
          themeString
        }
        onClick={() =>
          !disabled && this.props.onClick ? this.props.onClick() : null
        }
      >
        {this.props.label}
      </button>
    );
  }
}

export default RaisedButton;



// WEBPACK FOOTER //
// ./src/components/RaisedButton.js